var createjsClb = function createjsClb(srcLng, trgLng, srcKeys, trgKeys, ns, cb) {
  var js = {
    sourceLanguage: srcLng,
    targetLanguage: trgLng,
    resources: {}
  };

  if (!cb && (!ns || typeof ns !== 'string')) {
    cb = ns;
    ns = null;
  }

  if (ns && typeof ns === 'string') {
    js.resources[ns] = {};
    Object.keys(trgKeys).forEach(function (srcKey) {
      js.resources[ns][srcKey] = {
        source: srcKeys[srcKey] || '',
        target: trgKeys[srcKey] || ''
      };
    });
    if (cb) cb(null, js);
    return js;
  }

  Object.keys(trgKeys).forEach(function (ns) {
    js.resources[ns] = {};
    Object.keys(trgKeys[ns]).forEach(function (srcKey) {
      js.resources[ns][srcKey] = {
        source: srcKeys[ns][srcKey] || '',
        target: trgKeys[ns][srcKey] || ''
      };
    });
  });
  if (cb) cb(null, js);
  return js;
};

var createjs = function createjs(srcLng, trgLng, srcKeys, trgKeys, ns, cb) {
  if (!cb && ns === undefined) {
    return new Promise(function (resolve, reject) {
      return createjsClb(srcLng, trgLng, srcKeys, trgKeys, ns, function (err, ret) {
        return err ? reject(err) : resolve(ret);
      });
    });
  }

  if (!cb && typeof ns !== 'function') {
    return new Promise(function (resolve, reject) {
      return createjsClb(srcLng, trgLng, srcKeys, trgKeys, ns, function (err, ret) {
        return err ? reject(err) : resolve(ret);
      });
    });
  }

  return createjsClb(srcLng, trgLng, srcKeys, trgKeys, ns, cb);
};

createjs.createjsClb = createjsClb;
export default createjs;